module.exports = __webpack_public_path__ + "img/beijingse_5.aaf2e601.png";